export default __webpack_public_path__ + "1c49d0a869cc07991b4251a17c50a240.png";